import { useMutation, UseMutationOptions } from 'react-query';
import {
    createActivityType,
    updateActivityType,
    CreateActivityTypeBody,
    UpdateActivityTypeBody,
    ActivityType,
} from '../../services/apiSLTP/dailyReports/activityTypes';

interface UpdateActivityTypeParams {
    activityTypeId: string;
    data: UpdateActivityTypeBody;
}

export const useUpdateActivityTypeMutation = (options?: UseMutationOptions<ActivityType, Error, UpdateActivityTypeParams>) => {
    return useMutation<ActivityType, Error, UpdateActivityTypeParams>(
        ({ activityTypeId, data }) => updateActivityType(activityTypeId, data),
        options
    );
};

export const useCreateActivityTypeMutation = (options?: UseMutationOptions<ActivityType, Error, CreateActivityTypeBody>) => {
    return useMutation<ActivityType, Error, CreateActivityTypeBody>((data) => createActivityType(data), options);
};
